import Component from '../core/Component'
import support from '../utils/BrowserSupport'
import keycode from 'keycode'
import { enableScrolling, disableScrolling } from '../services/Scroll'
import EventBus from '../core/EventBus'
import { queries } from '../core/config'

export const STATES = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active'
}

export default class Nav extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            content: null,
            inner: null,
            body: null,
            labels: []
        }

    }

    prepare() {
        this.element.addEventListener(support.transitionEnd, event => {
            if (event.target === this.element) {
                if (!this.is(STATES.ACTIVE)) {
                    this.element.classList.remove(STATES.VISIBLE)
                    if ('scrollTo' in this.ref.body) {
                        this.ref.body.scrollTo(0, 0)
                    } else {
                        this.ref.body.scrollTop = 0
                    }
                    EventBus.emit('nav:afterclose')
                } else {
                    EventBus.emit('nav:afteropen')
                }
            }
        })

        this.ref.labels.forEach(label => {
            label.innerHTML = label
                .textContent
                .trim()
                .split('')
                .map(char => `<span class="Nav-letter" data-char="${char}">${char === ' ' ? '&nbsp;' : char}</span>`)
                .join('')
        })

        this.element.addEventListener('click', this.handleClick)
    }

    destroy() {
        this.close()
        document.removeEventListener('keydown', this.handleKeydown)
    }

    handleClick = event => {
        if (!this.element.contains(event.target)) {
            event.preventDefault()
            this.close()
        } else if (event.target.closest('a')) {
            const href = event.target.closest('a').getAttribute('href')
            if (event.target.closest('a[href^="#"]')) {
                event.preventDefault()
                EventBus.emit('nav:click', {
                    id: event.target.closest('a').getAttribute('href').replace('#', '')
                })
            }
            this.close()
        }
    }

    handleKeydown = event => {
        if (keycode(event.keyCode) === 'esc') {
            this.close()
        }
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }

    close() {
        if (!this.is(STATES.ACTIVE)) {
            return
        }
        this.element.classList.remove(STATES.ACTIVE)
        document.removeEventListener('keydown', this.handleKeydown)
        enableScrolling()
        EventBus.emit('nav:close')
    }

    open() {
        disableScrolling()
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
        document.addEventListener('keydown', this.handleKeydown)
        EventBus.emit('nav:open')
    }

}